
/**
* src/connects/attachment-file.js
* 
*/

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { validate } from '../helpers/form-validator'
import actions from '../actions'
import { translate } from 'react-i18next'
import ui from '../helpers/ui-state'

export const mapDispatchToProps = (dispatch)=> {
  return {
    showPdfPreview:  (file)=> {
      dispatch(actions.openRightSidePage('pdf_preview', { file: file }, true))
    },

    showVoicePlayer: (file, diary_id, comment_id)=> {
      dispatch(actions.openRightSidePage('voice_player', { file: file, diary_id: diary_id, comment_id: comment_id, isAudio: true }, true))
    }
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps),
  ui({ state: { openDialog: false }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/attachment-file.js